import { render, staticRenderFns } from "./PortfolioWriteUpdateLayout.vue?vue&type=template&id=450d2e34&scoped=true"
import script from "./PortfolioWriteUpdateLayout.vue?vue&type=script&lang=js"
export * from "./PortfolioWriteUpdateLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450d2e34",
  null
  
)

export default component.exports